const systemConfig = {
	login_title: '美中国际平台'
	, file_url: 'https://usaedu.griffinintl.net'

	//初始化分页
	, pageSizeOptions: [10, 20, 50, 100, 500]
	, pageSize: 10

	//编辑器两个配置
	, ueditorMini: [
		[
			'fullscreen', 'source', '|',
			'fontfamily', 'fontsize', 'bold', 'italic', 'underline', '|',
			'forecolor', 'backcolor', '|',
			'insertorderedlist', 'insertunorderedlist', '|',
			'justifyleft', 'justifycenter', 'justifyright', 'justifyjustify', '|',
			'horizontal', 'lineheight', '|',
			'link', 'unlink', 'insertimage', 'attachment', '|',
		],
	]
	, ueditorAll: [
		[
			'source', //源代码
			'|',
			'undo', //撤销
			'redo', //重做
			'|',
			'bold', //加粗
			'forecolor', //字体颜色
			'backcolor', //背景色
			'italic', //斜体
			'underline', //下划线
			'strikethrough', //删除线
			'horizontal', //分隔线
			'|',
			'fontfamily', //字体
			'fontsize', //字号
		], [
			'paragraph', //段落格式
			'justifyleft', //居左对齐
			'justifyright', //居右对齐
			'justifycenter', //居中对齐
			'justifyjustify', //两端对齐
			'indent', //首行缩进
			'rowspacingtop', //段前距
			'rowspacingbottom', //段后距
			'insertframe', //插入Iframe
			'imagenone', //默认
			'imageleft', //左浮动
			'imageright', //右浮动
			'imagecenter', //居中
			'insertorderedlist', //有序列表
			'insertunorderedlist', //无序列表
			'lineheight', //行间距
			'edittip ', //编辑提示
			'autotypeset', //自动排版
			'link', //超链接
			'unlink', //取消链接
			'formatmatch', //格式刷
			'removeformat', //清除格式
			'cleardoc', //清空文档
			'|',
			//'simpleupload', //单图上传
			'insertimage', //多图上传
			'attachment', //附件
			// 'insertvideo', //视频
			// 'map', //Baidu地图
			'fullscreen', //全屏
			'wordimage', //图片转存
			'|',
			'inserttable', //插入表格
			'edittable', //表格属性
			'edittd', //单元格属性
			'insertrow', //前插入行
			'insertcol', //前插入列
			'insertparagraphbeforetable', //"表格前插入行"
			'mergeright', //右合并单元格
			'mergedown', //下合并单元格
			'deleterow', //删除行
			'deletecol', //删除列
			'splittorows', //拆分成行
			'splittocols', //拆分成列
			'splittocells', //完全拆分单元格
			'deletecaption', //删除表格标题
			'inserttitle', //插入标题
			'mergecells', //合并多个单元格
			'deletetable', //删除表格
			'|',
			'background', //背景
			// 'subscript', //下标
			// 'fontborder', //字符边框
			// 'superscript', //上标
			// 'spechars', //特殊字符
			// 'preview', //预览
		]
	]
}
export default systemConfig